<template lang="pug">
  v-alert(
    color="primary darken-3"
    flat
    text
    dismissible
  ).sdo-radius.pa-10
    .mb-8
      h1 Вы зачислены
      .caption Текущий статус
    p Желаем вам комфортного обучения!
      |  Не забывайте пользоваться консультациями, не игнорируйте чаты в телеграмме.
    div
      p: strong Плановый срок завершения обучения
      div {{ course.priority_user_prior_record.end_learning | dp('d MMMM y') }}
    slot(name="slot" color="primary")
</template>

<script>
export default {
  props: {
    course: { type: Object, required: true },
  },
};
</script>
